import 'babel-polyfill';
import Vue from 'vue';
import Fragment from 'vue-fragment';
import store from './store';
import App from './containers/news-list-filter-app.vue';

// init app
Vue.config.devtools = true;
new Vue({
    store,
    components: {
        app: App
    },
}).$mount('#filter-app');